let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kQFf3")).then(() => parcelRequire('baR74'));